export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-enabled-960-fbd07caf94e8dc1e5814807560b9fb2d.webp";